var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"logo",on:{"click":_vm.listeners.openAppStore}},[_c('img',{attrs:{"src":"https://uploads.9fzt.com/production/jfztgwwap/assets/img/logo-jfzt.png","alt":""}}),_c('p',[_vm._v("立即下载")])])}
var staticRenderFns = []

export { render, staticRenderFns }